
import { RevDivider } from '@ds/components/Divider'
import { RevLink } from '@ds/components/Link'
import { IconClock } from '@ds/icons/IconClock'
import { IconSiren } from '@ds/icons/IconSiren'
import { IconTools } from '@ds/icons/IconTools'
import { mapGetters } from 'vuex'

import { COUNTRIES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { LEGAL_PAGE_NAME } from '@legal/constants'
import { ROUTES } from '@router'

import { LOCALES_WITH_WARRANTY_EXCLUSION } from './WarrantyModal.constant'
import translations from './WarrantyModal.translations'

const terms = {
  [COUNTRIES.FR]: {
    name: ROUTES.CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SALE,
    },
  },
  [COUNTRIES.BE]: {
    name: ROUTES.CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SALE,
    },
  },
  [COUNTRIES.PT]: {
    name: ROUTES.CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SALE,
    },
  },
  [COUNTRIES.US]: {
    name: ROUTES.CMS.LEGAL_PAGE,
    params: {
      pageName: LEGAL_PAGE_NAME.TERMS_SERVICE,
    },
  },
}

export default {
  components: {
    RevLink,
    IconSiren,
    IconClock,
    IconTools,
    RevDivider,
    FormattedMessage,
  },

  props: {
    warranty: {
      type: String,
      default: '',
    },
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      country: 'config/country',
      isLegalsInModal: 'config/cgvModalLegals',
      locale: 'config/locale',
    }),

    termsLocation() {
      return (
        terms[this.country] || {
          name: ROUTES.CMS.LEGAL_PAGE,
          params: {
            pageName: LEGAL_PAGE_NAME.TERMS_USE,
          },
        }
      )
    },

    warrantyLocation() {
      return {
        name: ROUTES.CMS.LEGAL_PAGE,
        params: {
          pageName: LEGAL_PAGE_NAME.WARRANTY,
        },
      }
    },

    isGermany() {
      return this.country === COUNTRIES.DE
    },

    showFirstLine() {
      return this.$t(translations.pointOneTitle)
    },

    showSecondLine() {
      return this.$t(translations.pointTwoTitle)
    },

    showThirdLine() {
      return this.$t(translations.pointThreeTitle)
    },

    showWarrantyExclusionLine() {
      return LOCALES_WITH_WARRANTY_EXCLUSION.includes(this.locale)
    },
  },
}
